import { useState } from 'react';
import Button from '../base/Button';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { name: 'About', path: '/about' },
  { name: 'Classes', path: '/classes' },
  { name: 'Schedule', path: '/schedule' },
  { name: 'Events', path: '/events' },
  // { name: 'Membership', path: '/membership' },
  { name: 'Membership', path: '/buy-now?_mt=%2Fbuy%2F48717' },
  { name: 'Contact Us', path: '/contact' },
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isEventsDropdownOpen, setIsEventsDropdownOpen] = useState(false);
  const location = useLocation();

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const element = document.querySelector(targetId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false);
    setIsAboutDropdownOpen(false);
    setIsEventsDropdownOpen(false);
  };

  const isActivePage = (path: string) => {
    return location.pathname === path;
  };

  const getNavLinkClass = (path: string) => {
    return isActivePage(path) 
      ? 'text-[#F6980E] font-medium' 
      : 'text-[#00889D] hover:text-[#F6980E] transition-colors font-medium';
  };

  return (
    <header className="bg-white h-28 header-box">
      <div className="max-w-7xl mx-auto px-6 h-full">
        <div className="flex items-center justify-between h-full">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img 
                src="/img/logo_header.png"
                alt="YOGA 7 Logo" 
                className="logo h-20 w-auto object-contain cursor-pointer"
              />
            </Link>
          </div>

          {/* Desktop Navigation and CTA Button Container */}
          <div className="hidden md:flex items-center gap-[30px]">
            <nav className="flex items-center space-x-6">
              {/*<a href="/" className={getNavLinkClass('/')}>*/}
              {/*  Home*/}
              {/*</a>*/}
              
              {/* About Dropdown */}
              <div 
                className="relative"
                onMouseEnter={() => setIsAboutDropdownOpen(true)}
                onMouseLeave={() => setIsAboutDropdownOpen(false)}
              >
                <button className={`transition-colors font-medium flex items-center ${isAboutDropdownOpen ? 'text-[#F6980E]' : 'text-[#00889D] hover:text-[#F6980E]'}`}>
                  About
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                {isAboutDropdownOpen && (
                  <div className="absolute top-full left-0 w-64 bg-white rounded-lg shadow-xl py-2 z-50 border-0">
                    <Link to="/studio" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                      Studio
                    </Link>
                    <Link to="/far-infrared-heat" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                      Far Infrared Heat
                    </Link>
                    <Link to="/our-values-&-ethics" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                      Our Values & Ethics
                    </Link>
                    <Link to="/terms" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                      Terms
                    </Link>
                    <Link to="/privacy-policy" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                     Privacy Policy
                    </Link>
                  </div>
                )}
              </div>

              <Link to="/classes" className={getNavLinkClass('/classes')}>
                Classes
              </Link>

              <Link to="/schedule" className={getNavLinkClass('/schedule')}>
                Schedule
              </Link>

              {/* Events Dropdown */}
              <div 
                className="relative"
                onMouseEnter={() => setIsEventsDropdownOpen(true)}
                onMouseLeave={() => setIsEventsDropdownOpen(false)}
              >
                <button className={`transition-colors font-medium flex items-center ${isEventsDropdownOpen ? 'text-[#F6980E]' : 'text-[#00889D] hover:text-[#F6980E]'}`}>
                  Events
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                {isEventsDropdownOpen && (
                    <div className="absolute top-full left-0 w-48 bg-white rounded-lg shadow-xl py-2 z-50 border-0">
                      <Link to="/events" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                        Events
                      </Link>
                      <Link to="/events-children" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                        Children
                      </Link>
                      <Link to="/events-adults" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                        Adults
                      </Link>
                    </div>
                )}
              </div>

              <Link to="/grandopening" className={getNavLinkClass('/grandopening')}>
                Grand Opening
              </Link>

              {/*<Link to="/membership" className={getNavLinkClass('/membership')}>*/}
              {/*  Membership*/}
              {/*</Link>*/}

              <Link to="/buy-now?_mt=%2Fbuy%2F48717" className={getNavLinkClass('/buy-now?_mt=%2Fbuy%2F48717')}>
                Membership
              </Link>

              <Link to="/contact" className={getNavLinkClass('/contact')}>
                Contact Us
              </Link>
            </nav>

            <Link to="/schedule" style={{width: 180}}>
              <Button size="lg" style={{width: 180}}>
                Book a Class
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden fixed left-0 right-0 bg-white shadow-lg border-t border-gray-100 z-50">
            <div className="max-w-7xl mx-auto px-6">
              <nav className="flex flex-col space-y-2 py-2">
                <div className="grid space-y-2">
                  {/* Mobile About Menu */}
                  <div>
                    <button 
                      onClick={() => setIsAboutDropdownOpen(!isAboutDropdownOpen)}
                      className={`flex items-center justify-between w-full transition-colors font-medium ${isAboutDropdownOpen ? 'text-[#F6980E]' : 'text-[#00889D] hover:text-[#F6980E]'}`}
                    >
                      About
                      <i className={`ri-arrow-down-s-line transition-transform ${isAboutDropdownOpen ? 'rotate-180' : ''}`}></i>
                    </button>
                    {isAboutDropdownOpen && (
                      <div className="mt-2 ml-4 space-y-1">
                        <Link to="/studio" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                          Studio
                        </Link>
                        <Link to="/far-infrared-heat" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                          Far Infrared Heat
                        </Link>
                        <Link to="/our-values-&-ethics" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                          Our Values & Ethics
                        </Link>
                        <Link to="/terms" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                          Terms
                        </Link>
                        <Link to="/privacy-policy" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#F6980E] transition-colors">
                          Privacy Policy
                        </Link>
                      </div>
                    )}
                  </div>

                  <Link to="/classes" className={getNavLinkClass('/classes')}>
                    Classes
                  </Link>

                  <Link to="/buy-now?_mt=%2Fbuy%2F48717" className={getNavLinkClass('/buy-now?_mt=%2Fbuy%2F48717')}>
                    Membership
                  </Link>

                  <Link to="/grandopening" className={getNavLinkClass('/grandopening')}>
                    Grand Opening
                  </Link>

                  <Link to="/schedule" className={getNavLinkClass('/schedule')}>
                    Schedule
                  </Link>

                  {/* Mobile Events Menu */}
                  <div>
                    <button 
                      onClick={() => setIsEventsDropdownOpen(!isEventsDropdownOpen)}
                      className={`flex items-center justify-between w-full transition-colors font-medium ${isEventsDropdownOpen ? 'text-[#F6980E]' : 'text-[#00889D] hover:text-[#F6980E]'}`}
                    >
                      Events
                      <i className={`ri-arrow-down-s-line transition-transform ${isEventsDropdownOpen ? 'rotate-180' : ''}`}></i>
                    </button>
                    {isEventsDropdownOpen && (
                      <div className="mt-2 ml-4 space-y-1">
                        <Link to="/events" className="block text-gray-600 hover:text-[#F6980E] transition-colors">
                          Events
                        </Link>
                        <Link to="/events-children" className="block text-gray-600 hover:text-[#F6980E] transition-colors">
                          Children
                        </Link>
                        <Link to="/events-adults" className="block text-gray-600 hover:text-[#F6980E] transition-colors">
                          Adults
                        </Link>
                      </div>
                    )}
                  </div>

                  <Link to="/contact" className={getNavLinkClass('/contact')}>
                    Contact
                  </Link>
                </div>
              </nav>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
